import { SelectProps } from '@amzn/awsui-components-core/select';
import { IconProps } from '@amzn/awsui-components-core/icon';

const CLOUDSCAPE_ICONS: IconProps.Name[] = [
  'add-plus',
  'angle-left',
  'angle-right',
  'audio-full',
  'bug',
  'call',
  'calendar',
  'caret-down-filled',
  'caret-right-filled',
  'caret-up-filled',
  'check',
  'contact',
  'copy',
  'close',
  'delete-marker',
  'download',
  'drag-indicator',
  'edit',
  'ellipsis',
  'envelope',
  'expand',
  'external',
  'file',
  'file-open',
  'filter',
  'flag',
  'folder',
  'folder-open',
  'gen-ai',
  'group',
  'heart',
  'insert-row',
  'key',
  'keyboard',
  'lock-private',
  'menu',
  'microphone',
  'multiscreen',
  'notification',
  'redo',
  'refresh',
  'remove',
  'resize-area',
  'script',
  'search',
  'security',
  'settings',
  'share',
  'shrink',
  'star',
  'star-filled',
  'status-in-progress',
  'status-info',
  'status-negative',
  'status-pending',
  'status-positive',
  'status-stopped',
  'status-warning',
  'suggestions',
  'thumbs-down',
  'thumbs-down-filled',
  'thumbs-up',
  'thumbs-up-filled',
  'ticket',
  'treeview-collapse',
  'treeview-expand',
  'undo',
  'unlocked',
  'upload',
  'upload-download',
  'user-profile',
  'user-profile-active',
  'video-off',
  'video-on',
  'view-full',
  'view-horizontal',
  'view-vertical',
  'zoom-in',
  'zoom-out'
];

const FA_ICONS = [
  'chart-bar',
  'chart-line',
  'chart-pie',
  'chart-area',
  'table',
  'database',
  'server',
  'cloud',
  'code',
  'cog',
  'cogs',
  'tools',
  'wrench',
  'file-alt',
  'file-excel',
  'file-pdf',
  'file-code',
  'folder',
  'calculator',
  'money-bill',
  'dollar-sign',
  'building',
  'briefcase',
  'users',
  'user-shield',
  'shield-alt',
  'lock',
  'globe',
  'sitemap',
  'project-diagram',
  'tasks',
  'clipboard-list',
  'bell',
  'bolt',
  'rocket',
  'bullseye',
  'flag',
  'trophy',
  'puzzle-piece'
];

export const BUNDLED_LOGO_OPTIONS: SelectProps.OptionGroup[] = [
  {
    label: 'Cloudscape Icons',
    options: CLOUDSCAPE_ICONS.map((name) => ({
      value: `cloudscape:${name}`,
      label: name,
      iconName: name
    }))
  },
  {
    label: 'FontAwesome Icons',
    options: FA_ICONS.map((name) => ({
      value: `fa:${name}`,
      label: name,
      labelTag: 'FA'
    }))
  }
];
